var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-template"},[_c('home-user'),_vm._m(0),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-logo"},[_c('img',{attrs:{"src":require("../assets/logo.svg"),"alt":""}})])
}]

export { render, staticRenderFns }